<script>
export default {
  name: "TabsSelector",

  props: {
    value: {
      type: String,
      required: true,
      default: "TransactionHistory",
    },
  },

  data: () => ({
    tabs: [
      {
        text: "Transaction History",
        value: "TransactionHistory",
        className: "first",
      },
      {
        text: "Game History",
        value: "GameHistory",
        className: "last",
      },
      // {
      //   text: "Bonus History",
      //   value: "BonusHistory",
      //   className: "last",
      // },
    ],
  }),

  computed: {
    selectedTab() {
      return this.tabs.find((item) => item.value === this.value);
    },
    filteredTabs() {
      return this.tabs.filter((item) => item.value !== this.value);
    },
  },

  methods: {
    setSelectedTab(tab) {
      this.$emit("change", tab.value);
    },
  },
};
</script>

<template>
  <div>
    <v-tabs
      class="vuetify-tabs"
      fixed-tabs
      height="76"
      color="#48305c"
      hide-slider
    >
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        :ripple="false"
        :class="tab.className"
        class="font-weight-superbold font-size-24"
        @click="setSelectedTab(tab)"
      >
        {{ tab.text }}
      </v-tab>
    </v-tabs>
    <div class="custom-tabs">
      <div
        v-for="(tab, index) in filteredTabs"
        :key="index"
        :class="selectedTab === tab.value ? '' : ''"
        class="custom-tab font-weight-superbold text-center cursor-pointer py-3"
        @click="setSelectedTab(tab)"
      >
        <span style="z-index: 2" class="position-relative">
          {{ tab.text }}
        </span>
      </div>
      <div
        class="custom-tab custom-tab--is-active font-weight-superbold text-center cursor-pointer py-3"
      >
        {{ selectedTab && selectedTab.text }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.v-tabs::v-deep {
  .v-tabs-bar {
    background: transparent;

    .v-tab {
      background: #847ab1;
      color: #aba5ce;
      transition: 0.2s;
      letter-spacing: 0;

      &.v-tab--active {
        background: #412a55;
        color: white;

        &:before {
          opacity: 0 !important;
        }

        &::after {
          background-image: url("/images/divider.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          height: 4px;
          width: 100%;
          border-radius: 15px;
        }
      }

      &.first {
        border-top-left-radius: 20px !important;

        &::before,
        &::after,
        .v-ripple__container {
          border-top-left-radius: 20px !important;
        }
      }

      &.last {
        border-top-right-radius: 20px !important;
        margin-left: 8px;

        &::before,
        &::after,
        .v-ripple__container {
          border-top-right-radius: 20px !important;
        }
      }

      &:not(.first):not(.last) {
        margin-left: 8px;
        margin-right: 8px;
      }

      &:not(.v-tab--active):hover {
        background: #412a55;
        color: white;
      }
    }
  }
}

.custom-tabs {
  display: none;

  .custom-tab {
    position: relative;
    //overflow: hidden;
    //background: #847ab1;
    background: #766d9f;
    color: #aba5ce;
    transition: 0.2s;
    font-size: 24px;

    &.custom-tab--is-active {
      background: #412a55;
      color: white;
    }

    &.custom-tab--is-active {
      font-size: 32px;

      &::after {
        background-image: url("/images/divider.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        border-radius: 15px;
      }
    }

    &:first-child {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }

    &:nth-child(2) {
      &::before {
        transform: scale(-1, 1);
      }
    }

    &::before {
      content: "";
      position: absolute;
      bottom: -14px;
      left: 0;
      width: 100%;
      height: 36px;
      background-image: url("/images/history-shadow.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      z-index: 1;
    }
  }
}

@media screen and (max-width: 768px) {
  .vuetify-tabs {
    display: none;
  }

  .custom-tabs {
    display: block;
  }
}
</style>
